<template>
  <div class="apply-step apply-step--terminal">
    <div class="apply-step__icon">🎬</div>
    <h2>Tu postulación está en revisión</h2>
    <p>Nuestro equipo de RRHH está revisando tu video de presentación y tus documentos.</p>
    <p>Te confirmaremos el resultado por WhatsApp al celular que registraste.</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ResultVideoReview',
  mounted() { this.clearAll() },
  methods: { ...mapActions('apply', ['clearAll']) },
}
</script>

<style src="../apply-step.css" scoped></style>
<style scoped>
.apply-step--terminal { text-align: center; padding: 2rem 1rem; }
.apply-step__icon { font-size: 4rem; margin-bottom: 1rem; }
</style>
